import { MODULES } from "./Constants";

export const getNotificationPath = (userRoles) => {
  if (userRoles.includes("administrador")) {
    return "/conf-notificaciones/menu";
  }

  //Si tiene acceso a más de un módulo, redirigir al menú principal
  const accessibleModules = Object.values(MODULES).filter(module =>
    module.responsibles.some(role => userRoles.includes(role))
  );

  if (accessibleModules.length > 1){
    return "/conf-notificaciones/menu";
  }

  // Buscar el primer módulo donde el usuario tenga un rol responsable
  for (const key in MODULES) {
    const module = MODULES[key];
    if (module.responsibles.some(role => userRoles.includes(role))) {
      return module.path;
    }
  }

  // Si no se encuentra, se puede retornar null o una ruta por defecto
  return null;
};